import { render, staticRenderFns } from "./MonthlyValuesCompare.vue?vue&type=template&id=22df848e&scoped=true"
import script from "./MonthlyValuesCompare.vue?vue&type=script&lang=js"
export * from "./MonthlyValuesCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22df848e",
  null
  
)

export default component.exports